export default __webpack_public_path__ + "static/media/tresClosed.8279073a.jpg";